import React, { Fragment } from "react";
import { useHistory } from "react-router-dom";
import { Title } from "@nykaa/payment-ui/src/Title";
import { MessageCard } from "@nykaa/payment-ui/src/MessageCard";
import { DesktopPaymentMethodCard } from "@nykaa/payment-ui/src/DesktopPaymentOfferCard";
import { Text } from "@nykaa/payment-ui/src/Text";
import { BottomSheet } from "@nykaa/payment-ui/src/BottomSheet/BottomSheet";
import { OfferCardLayout } from "@nykaa/payment-sdk/src/OfferCard";
import {
  CustomPaymentOfferCommonMobile,
  MessageCardWrapper,
  Wrapper,
  OfferBottomSheetListWrapper,
  OffersBottomSheetHeaderWrapper,
} from "../assets/style";
import { PaymentOfferMobileConfig } from "../@types";


export const PaymentOfferListView = (config: PaymentOfferMobileConfig) => {
  const history = useHistory();
  const {
    paymentOfferTitle,
    paymentOfferTitleFont,
    paymentOfferTitleColor,
    messageCard,
    messageCardActionButtonText,
    bankConfig,
    isPaymentOfferRevampEnabled,
    bottomSheetVisible,
    bottomSheetIcon,
    bottomSheetClose,
    theme,
  } = config;

  return (
    <BottomSheet
      isVisible={bottomSheetVisible}
      onClose={bottomSheetClose}
      icon={bottomSheetIcon}
      height={"75%"}
      maxHeight={75}
      theme={theme}
      noContentPadding={true}
      onIconClick={bottomSheetClose}
      iconLabel="Close"
      history={history as any}
    >
      {isPaymentOfferRevampEnabled ? (
        <>
          <OffersBottomSheetHeaderWrapper>
            <Text
              htmlText={paymentOfferTitle}
              font={theme.typography.titleLarge}
              color={theme.primaryText}
              theme={theme}
            />
            <Text
              htmlText={messageCard?.messageCardText}
              font={theme.typography.bodyLG}
              color={theme.secondaryText}
              theme={theme}
            />
          </OffersBottomSheetHeaderWrapper>
          <OfferBottomSheetListWrapper>
            {bankConfig?.map((data, index: number) => {
              const { leadingIcon, offerTitle, title, subTitle, onClick, validityConfig } = data;
              return (
                <Fragment key={`offercard-${index}`}>
                  <OfferCardLayout
                    keyId={`offercard-${index}`}
                    isDisable={validityConfig?.isDisable}
                    leadingIcon={leadingIcon as string}
                    offerTitle={offerTitle}
                    title={title}
                    subTitleFont={validityConfig?.font}
                    subTitle={validityConfig?.message || subTitle}
                    subTitleClickHandler={validityConfig?.handleRemoveCoupon}
                    subtitleColor={validityConfig?.color || ""}
                    currOfferIndex={index}
                    offersLength={bankConfig.length}
                    onClick={() => onClick && onClick(false)}
                    theme={theme}
                  />
                </Fragment>
              );
            })}
          </OfferBottomSheetListWrapper>
        </>
      ) : (
        <Wrapper>
          <Title
            text={paymentOfferTitle}
            color={paymentOfferTitleColor}
            font={paymentOfferTitleFont}
            theme={theme}
          />
          <CustomPaymentOfferCommonMobile className="payment-offers-common">
            <MessageCardWrapper>
              <MessageCard
                message={{
                  text: messageCard?.messageCardText,
                  leadingIcon: messageCard?.messageCardLeadingIcon,
                  info: messageCard?.messageCardInfo,
                  font: messageCard?.messageCardFont,
                  color: messageCard?.messageCardColor,
                }}
                actionButtonText={messageCardActionButtonText}
                theme={theme}
              />
            </MessageCardWrapper>
            {bankConfig.map((bank, index: number) => (
              <DesktopPaymentMethodCard
                key={`bank-${index}`}
                leadingIcon={bank.leadingIcon}
                title={bank.title}
                titleFont={bank.titleFont}
                titleColor={bank.titleColor}
                subTitle={bank.subTitle}
                subTitleColor={bank.subTitleColor}
                subTitleFont={bank.subTitleFont}
                offerTitle={bank.offerTitle}
                offerTitleFont={bank.offerTitleFont}
                offerTitleColor={bank.offerTitleColor}
                infoTitle={bank.infoTitle}
                infoTitleColor={bank.infoTitleColor}
                infoTitleFont={bank.infoTitleFont}
                negativeTitle={bank.negativeTitle}
                negativeTitleFont={bank.negativeTitleFont}
                negativeTitleColor={bank.negativeTitleColor}
                theme={theme}
                onClick={bank.onClick}
                noSidePadding={bank.noSidePadding}
                icon={bank.icon}
                noPadding={bank.noPadding}
              />
            ))}
          </CustomPaymentOfferCommonMobile>
        </Wrapper>
      )}
    </BottomSheet>
  );
};
